import API from 'utils/api';
import getFormattedValues from 'utils/formatValues';
import { onError, onSuccess } from 'utils/handlers';

export const baseURI = 'nominas/liquidaciones-empleados';
export const baseURI2 = 'nominas/liquidaciones-empleados-vista-optimized';

const getValuesAndConfig = (values) => {
  const config = {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  };
  const formattedValues = getFormattedValues(values, {
    formData: config.headers,
    clean: false,
  });
  return [formattedValues, config];
};

/**
 * GET Liquidaciones Empleados
 * @param {object} params
 * @returns {Promise<object[]>}
 */
export const getLiquidacionesEmpleados = async (params) => {
  try {
    const response = await API.get(baseURI2, { params });
    return response.data;
  } catch (err) {
    onError(err);
  }
  return [];
};

/**
 * GET Liquidacion Empleado
 * @param {number} id
 * @returns {Promise<object|null>}
 */
export const getLiquidacionEmpleado = async (id) => {
  try {
    const response = await API.get(`${baseURI}/${id}`);
    return response.data;
  } catch (err) {
    onError(err);
  }
  return null;
};

/**
 * POST Liquidacion Empleado
 * @param {object} values
 * @returns {Promise<object|boolean>}
 */
export const postLiquidacionEmpleado = async (values) => {
  try {
    const response = await API.post(baseURI, ...getValuesAndConfig(values));
    onSuccess(response, 'Agregado correctamente');
    return response.data;
  } catch (err) {
    onError(err);
    return false;
  }
};

/**
 * PATCH Liquidacion Empleado
 * @param {number} id
 * @param {object} values
 * @returns {Promise<object|boolean>}
 */
export const patchLiquidacionEmpleado = async (id, values) => {
  try {
    const response = await API.patch(`${baseURI}/${id}`, ...getValuesAndConfig(values));
    onSuccess(response, 'Editado correctamente');
    return response.data;
  } catch (err) {
    onError(err);
    return false;
  }
};

/**
 * POST Recalcular Liquidacion Empleado
 * Vuelve a generar el detalle (Percepciones/Deducciones/Descuentos de Finiquito e
 * Indemnización) de una Liquidación de Empleado ya existente, a partir de su estado
 * actual guardado (Administración de Plaza, Fecha de Baja, Periodo de Nómina, etc.),
 * sin crear un nuevo registro ni perder su folio.
 * @param {number} id
 * @returns {Promise<object|boolean>}
 */
export const recalcularLiquidacionEmpleado = async (id) => {
  try {
    const response = await API.put(`${baseURI}/${id}/recalcular`);
    onSuccess(response, 'Liquidación recalculada correctamente');
    return response.data;
  } catch (err) {
    onError(err);
    return false;
  }
};

/**
 * DELETE Liquidacion Empleado
 * @param {number} id
 * @returns {Promise<boolean>}
 */
export const deleteLiquidacionEmpleado = async (id) => {
  try {
    const response = await API.delete(`${baseURI}/${id}`);
    onSuccess(response, 'Eliminado correctamente');
    return true;
  } catch (err) {
    onError(err);
    return false;
  }
};
